// Grabs query parameter from url
import { useLocation } from "react-router-dom";

export const useQuery = (param: string) => {
  const search = useLocation().search;
  return new URLSearchParams(search).get(param);
};

interface IQueryParams {
  [key: string]: string;
}

export const useQueryParams = <T extends any>() => {
  const { search } = useLocation<T>();

  const params = search
    .slice(1)
    ?.split("&")
    .reduce((acc: IQueryParams, curr) => {
      const [key, value] = curr?.split("=");
      acc[key] = value;
      return acc;
    }, {}) as T;

  return params;
};
